<script>
// 扩展<el-input> 计数器
import { Input } from 'element-ui';
export default {
  props: ['counter'],
  mixins: [Input],
  data() {
    return {
    }
  },
  mounted() {
    if(this.counter != undefined) {
      var count = document.createElement('span');
      count.className = 'count'
      this.$el.appendChild(count);
      this.refCount();
    }
    
  },
  watch: {
    currentValue: function() {
      this.counter != undefined && this.refCount();
    },
  },
  computed: {

  },
  methods: {
    // 刷新计数器
    refCount: function() {
      var maxlength = this.counter ? this.counter : 200;
      this.$attrs.maxlength = maxlength;
      var count = this.$el.querySelector('span');
      var curLen = typeof this.currentValue === 'string'? this.currentValue.length : 0;
      count.innerHTML = `${curLen}/${maxlength}`;
    },
  },
}
</script>
<style lang="scss" scoped>
  .el-textarea {
    position: relative;
    color: $theme-textnormal;
  }
  /deep/ .count{
    position: absolute;
    bottom: 8px;
    right: 12px;
    font-size: 12px;
    line-height: 17px;
    color: $theme-textplaceholder;
  }
</style>

